/**
 * @generated SignedSource<<a9293b11e5453571309be8d0b437ffa4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CancelDeal_metadata$data = {
  readonly receivedAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly " $fragmentSpreads": FragmentRefs<"StackedAssetMedia_assets">;
    };
  }>;
  readonly sentAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly " $fragmentSpreads": FragmentRefs<"StackedAssetMedia_assets">;
    };
  }>;
  readonly " $fragmentType": "CancelDeal_metadata";
};
export type CancelDeal_metadata$key = {
  readonly " $data"?: CancelDeal_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"CancelDeal_metadata">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AssetType",
    "kind": "LinkedField",
    "name": "asset",
    "plural": false,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "StackedAssetMedia_assets"
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CancelDeal_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "sentAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "receivedAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};
})();

(node as any).hash = "31df7ae1a0f82af585accb443800803b";

export default node;
